import { render, staticRenderFns } from "./integration-service-failures-sheet.vue?vue&type=template&id=35049363&scoped=true"
import script from "./integration-service-failures-sheet.vue?vue&type=script&lang=js"
export * from "./integration-service-failures-sheet.vue?vue&type=script&lang=js"
import style0 from "./integration-service-failures-sheet.vue?vue&type=style&index=0&id=35049363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35049363",
  null
  
)

export default component.exports